export default __webpack_public_path__ + "static/media/Connect-nonclick.c282cd51.svg";